var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm.label ? [_vm._v(_vm._s(_vm.label))] : _vm.hasCustomValue ? _c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };